import { css } from "@emotion/react";
import { TridimentionalWhatsIcon, spaikIcon } from "../../assets";
import { AuthContextType, useAuth } from "../../auth/auth-provider";

export const LeftDisabledBox: React.FC = () => {
  const { user } = useAuth() as AuthContextType;

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        height: 100%;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: flex-end;
          width: 100%;
        `}
      >
        <div className="mr-5">
          <img src={TridimentionalWhatsIcon} alt="3dWhats" />
        </div>

        <div>
          <div
            css={css`
              font-size: 14px;
              font-weight: 600;
              color: #0a043c;
            `}
          >
            Todas as conversas em um único lugar!
          </div>

          <div
            css={css`
              font-size: 12px;
              color: #544f77;
            `}
          >
            Para integrar essa ferramenta incrível, basta conectar o seu
            celular, vamos integrar todas as mensagens do seu Bot em um único
            local.
          </div>
        </div>
      </div>

      <div
        css={css`
          display: flex;
          justify-content: center;
          width: 100%;
          height: 100%;
        `}
      >
        {user.plataform.urlAvatar ? (
          <img
            src={user.plataform.urlAvatar}
            alt="createBotImage"
            style={{ width: "280px" }}
          />
        ) : (
          <img
            src={spaikIcon}
            alt="createBotImage"
            style={{ width: "280px" }}
          />
        )}
      </div>
    </div>
  );
};
